import {
  BookOpenText,
  Camera,
  Cat,
  Gamepad2,
  Heart,
  Megaphone,
  MessagesSquare,
  Palette,
  Sparkles,
} from 'lucide-react'

export const sanctuaryRooms = [
  { name: 'The Hearth', description: 'The heart of the sanctuary — settle in, say hello and share the shape of your day.', icon: Heart, tone: 'ember' },
  { name: 'Gaming', description: 'Find a party, share what you are playing or join a relaxed game night.', icon: Gamepad2, tone: 'violet' },
  { name: 'Crafting Nook', description: 'A quiet corner for makes, works in progress, creative wins and helpful encouragement.', icon: Palette, tone: 'rose' },
  { name: 'The Coven', description: 'A little moonlit magic for curious minds, kindred spirits and thoughtful conversation.', icon: Sparkles, tone: 'indigo' },
  { name: 'Enchanted Library', description: 'Books, stories, recommendations and all the worlds waiting between the pages.', icon: BookOpenText, tone: 'blue' },
  { name: 'Familiars', description: 'A dedicated place for pets, companions and the creatures who make home feel warmer.', icon: Cat, tone: 'gold' },
  { name: 'Photos', description: 'Share the small, beautiful and memorable moments from life beyond the screen.', icon: Camera, tone: 'plum' },
  { name: 'Socials', description: 'Keep in touch, share your channels and celebrate what the community is making.', icon: MessagesSquare, tone: 'teal' },
  { name: 'Announcements', description: 'The latest sanctuary news, plans, gatherings and things worth knowing.', icon: Megaphone, tone: 'amber' },
]
